import {Occupancy} from "@variocube/app-api";

export interface Address {
    street: string;
    houseNo: string;
    zip: string;
    city: string;
    country: string;
}

export interface Shop {
    accessCode: string;
    address: Address;
    vendInShop: string;
}

export interface Category {
    id: string;
    name: string;
    image: string;
}

export interface TaxedSum {
    net: number;
    taxRate: number;
    tax: number;
    gross: number;
}

export interface Product {
    id: string;
    name: string;
    description: string;
    image: string;
    category: string;
    price: TaxedSum;
}

export class TaxedSumWrapper {

    readonly taxedSum: TaxedSum;

    constructor(taxedSum: TaxedSum) {
        this.taxedSum = taxedSum;
    }

    static fromNet(net: number, taxRate: number = 20): TaxedSumWrapper {
        const tax = net * (taxRate / 100);
        const gross = net + tax;
        return new TaxedSumWrapper({
            net: net,
            taxRate: taxRate,
            tax: tax,
            gross: gross
        });
    }

    static random(min: number = 5, max: number = 20): TaxedSumWrapper {
        const net = min + (Math.random() * (max - min));
        return this.fromNet(net);
    }

}

export interface VendingOccupancyContent {
    /** The product uuid */
    product: string;
}

export interface VendProduct {
    occupancy: Occupancy;
    product:  Product;
}

export function getVendingOccupancyContent(occupancy: Occupancy) {
    if (occupancy.content.product) {
        return occupancy.content as VendingOccupancyContent;
    }
}
